import { ReactComponent as Copy } from "./copy-paste.svg";
import { ReactComponent as Email } from "./email.svg";
import { ReactComponent as Imdb } from "./imdb.svg";
import { ReactComponent as Instagram } from "./instagram.svg";
import { ReactComponent as Linktree } from "./linktree.svg";
import { ReactComponent as Play } from "./play.svg";
import { ReactComponent as Vimeo } from "./vimeo.svg";

const SvgImages = {
  copy: Copy,
  play: Play,
  instagram: Instagram,
  linktree: Linktree,
  vimeo: Vimeo,
  email: Email,
  imdb: Imdb,
  // Add more SVG imports here as needed
};

export default function getImage(iconName) {
  const image = SvgImages[iconName];
  if (!image) {
    console.warn(`SVG image "${iconName}" not found.`);
  }
  return image || null;
}
